import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultIcon2 from '$components/DefaultIcon2/DefaultIcon2';
import classes from './EmployeeCard.module.css';
import { Candidate } from '../../../types/candidates';

interface Props {
  employee: Candidate;
  jobTitle: string | undefined;
  acceptanceDate: Date;
}

const EmployeeCard: FC<Props> = ({ employee, jobTitle, acceptanceDate }) => {
  const [t] = useTranslation('global');

  return (
    <li className={classes.Card} data-testid="employeeCard">
      <div className={classes.Content}>
        <div className=" w-24">
          <DefaultIcon2
            firstName={employee?.User?.FirstName}
            lastName={employee?.User?.LastName}
            picture={employee?.User?.ProfilePicture?.Url}
            fontSize="text-4xl"
          />
        </div>
        <h3
          className={classes.Name}
        >{`${employee.User?.FirstName} ${employee.User?.LastName}`}</h3>
        <div className={classes.Chip}>
          <p className={classes.ChipText}>{jobTitle}</p>
        </div>
        <p className={classes.EmployeeSince}>
          {`${t('TeamMembers.StartDate')} `}
          {acceptanceDate.toLocaleString('en-us', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </p>
      </div>
      <a
        className={classes.ViewProfileLink}
        href={`${import.meta.env.REACT_APP_SPK_URL}/spk/${employee.Id}`}
        target="_blank"
        rel="noreferrer"
        data-testid="employeeViewProfile"
      >
        {t('CandidatePositionSummaryCard.ViewProfile')}
      </a>
    </li>
  );
};

export default EmployeeCard;
